import { SignalAILoadingState } from '../SignalAILoadingState';

export const ImportLoadingStep = () => {
  return (
    <div className="h-full flex items-center justify-center mx-10">
      <SignalAILoadingState />
    </div>
  );
};
